module.exports = __webpack_public_path__ + "img/profile-pic.ce98e4ba.jpg";